var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import { useCFToggle } from '@connectrn/ds-ui-base';
import { commonAttrs } from '../../utils';
import { CFCheckboxElements } from './Checkbox.styles';
import { CFCheckboxSVG } from './CheckboxSVG';
export const CFCheckbox = (_a) => {
    var { alternateTheme, checked, disabled, id, name, onChange, value } = _a, rest = __rest(_a, ["alternateTheme", "checked", "disabled", "id", "name", "onChange", "value"]);
    const { checked: internalChecked, setChecked, updateChecked, } = useCFToggle({
        initialChecked: checked,
        onChange,
    });
    const { Input, Root } = CFCheckboxElements;
    const onToggleChange = (event) => {
        updateChecked(event.target.checked, event);
    };
    useMemo(() => {
        setChecked(checked || false);
    }, [checked]);
    return (React.createElement(Root, Object.assign({ htmlFor: id }, commonAttrs(rest)),
        React.createElement(Input, { checked: internalChecked, disabled: disabled, id: id, name: name, onChange: onToggleChange, type: 'checkbox', value: value }),
        React.createElement(CFCheckboxSVG, { alternateTheme: alternateTheme, disabled: disabled, selected: internalChecked })));
};
